import React from "react";

const InternalServerError: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary">
      <div className="text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-lightGray">500</h1>
        </div>
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-textHeadingColor mb-4">Internal Server Error</h2>
          <p className="text-textSecondaryColor text-lg">Something went wrong on our end. Please try again later.</p>
        </div>
        <div className="space-y-4">
          <button
            onClick={() => window.location.reload()}
            className="bg-buttonColor hover:bg-textHeadingColor text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default InternalServerError;
